import React, { FC } from 'react';
import { User } from 'models/User';
import classNames from 'classnames';
import ResolveImage from 'components/ResolveImage';
import { getImgUrl } from 'components/ResolveImage/utils';
import { SIZE, Size } from 'models/Size';
import { XOR } from 'types';

import './AvatarWithInitials.styles.scss';

type AvatarWithInitialsProps = {
  className?: string;
  size?: Size;
} & XOR<{ user: Partial<User> }, { initials?: string }>;

const AvatarWithInitials: FC<AvatarWithInitialsProps> = ({
  className,
  user,
  initials,
  size = SIZE.SMALL,
}) => {
  const classses = classNames(
    'avatar-with-initials',
    `avatar-with-initials--${size}`,
    className,
  );

  const { firstName, lastName, profileImage } = user || {};

  const avatarUrl = profileImage?.url;
  const hasAvatarLogo = avatarUrl || (!firstName && !lastName && !initials);

  return hasAvatarLogo ? (
    <ResolveImage
      asAvatar
      className={classses}
      src={getImgUrl(avatarUrl, '100')}
    />
  ) : (
    <span className={classNames(classses, 'initials')}>
      {initials ? (
        initials
      ) : (
        <>
          {firstName[0]}
          {lastName && lastName[0]}
        </>
      )}
    </span>
  );
};

export default AvatarWithInitials;
